import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LinkedInIcon } from "./LinkedInIcon";
import { CONTACT, NAV_LINKS } from "../data/content";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-[#0D1B2A] text-white">
    <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16 lg:py-20">
      <div className="grid grid-cols-1 gap-x-12 gap-y-6 lg:grid-cols-12">
        {/* Row 1: logo */}
        <div className="lg:col-span-7">
          <div className="max-w-2xl">
            <Logo dark imgClassName="h-16 md:h-20 w-auto" />
          </div>
        </div>
        {/* Row 1: Get in touch label, bottom-aligned above names */}
        <div className="lg:col-span-5 lg:col-start-8 flex items-end">
          <h4 className="text-base font-bold uppercase tracking-[0.2em] text-[#FD8924]">Get in touch</h4>
        </div>

        {/* Row 2: copy + CTA */}
        <div className="lg:col-span-7 self-start">
          <div className="max-w-2xl">
            <p className="text-base text-white/70 leading-relaxed">
              A strategic stakeholder communications firm helping complex organizations communicate
              strategy, performance, sustainability, and long-term value with clarity.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#FD8924]/50 px-6 py-3 text-sm font-semibold text-[#FD8924] hover:bg-[#FD8924] hover:text-[#0D1B2A] transition-colors duration-200"
            >
              Start a Conversation <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
        {/* Row 2: names */}
        <div className="lg:col-span-5 lg:col-start-8 self-start">
          <div className="flex flex-col gap-8 sm:flex-row sm:gap-14">
            {CONTACT.partners.map((p) => (
              <div key={p.email} className="text-base text-white/60 leading-relaxed">
                <div className="font-semibold text-white">{p.name}</div>
                <div className="text-sm text-white/40">{p.role}</div>
                <a href={`mailto:${p.email}`} className="mt-3 block hover:text-[#FD8924] transition-colors duration-200">{p.email}</a>
                <a href={p.phoneHref} className="mt-1 block hover:text-[#FD8924] transition-colors duration-200">{p.phone}</a>
                {p.linkedin && (
                  <a
                    href={p.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${p.name} on LinkedIn`}
                    data-testid={`footer-linkedin-${p.name.split(" ")[0].toLowerCase()}`}
                    className="mt-3 inline-flex text-white/70 hover:text-white transition-colors duration-200"
                  >
                    <LinkedInIcon className="h-6 w-6" />
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar: subtle nav + legal */}
      <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
        <p className="text-xs text-white/40 order-2 md:order-1">
          © {new Date().getFullYear()} Big Pivot Partners. All rights reserved.
        </p>
        <nav className="order-1 md:order-2 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs" aria-label="Footer">
          {NAV_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="text-white/50 hover:text-white transition-colors duration-200">
              {l.label}
            </Link>
          ))}
          <Link to="/privacy" data-testid="footer-privacy-link" className="text-white/50 hover:text-white transition-colors duration-200">
            Privacy
          </Link>
        </nav>
      </div>
    </div>
  </footer>
);
